import * as EventActions from '../actions/event'
import { Event } from '../models'

export interface State {
  resourceId: number
  events: Event[]
  didAsk: boolean
}

const initialState: State = {
  resourceId: null,
  events: [],
  didAsk: false
}

export function videoReducer(state: State = initialState, action: EventActions.VideoAll): State {
  switch (action.type) {
    case EventActions.INIT_EVENTS_ON_VIDEO: {
      return {
        resourceId: null,
        events: [],
        didAsk: false
      }
    }
    case EventActions.LOAD_EVENTS_ON_VIDEO: {
      return {
        resourceId: action.videoId,
        events: action.events.sort((a, b) => a.position - b.position),
        didAsk: false
      }
    }
    case EventActions.UPDATE_EVENT_ON_VIDEO: {
      const updateIndex = state.events.findIndex((e) => e.id === action.event.id)
      // 存在しなければ何もしない
      if (updateIndex === -1) return state
      
      // 更新
      state.events[updateIndex] = action.event

      return {
        ...state,
        events: [...state.events]
      }
    }
    case EventActions.ADD_EVENT_ON_VIDEO: {
      return {
        ...state,
        didAsk: (action.event.kind === 'comment' && action.enabledChatgpt) as boolean,
        events: [...state.events, action.event].sort((a, b) => a.position - b.position)
      }
    }
    case EventActions.REMOVE_EVENT_ON_VIDEO: {
      const removeIndex = state.events.findIndex((e) => e.id === action.eventId)
      // 存在しなければ何もしない
      if(removeIndex === -1) return state

      // 削除
      state.events.splice(removeIndex, 1)

      return {
        ...state,
        events: [...state.events]
      }
    }

    default: {
      return state
    }
  }
}

export function staticContentReducer(state: State = initialState, action: EventActions.StaticContentAll): State {
  switch (action.type) {
    case EventActions.INIT_EVENTS_ON_STATIC_CONTENT: {
      return {
        resourceId: null,
        events: [],
        didAsk: false
      }
    }
    case EventActions.LOAD_EVENTS_ON_STATIC_CONTENT: {
      return {
        resourceId: action.staticContentId,
        events: action.events.sort((a, b) => a.position - b.position),
        didAsk: false
      }
    }
    case EventActions.ADD_EVENT_ON_STATIC_CONTENT: {
      return {
        ...state,
        didAsk: (action.event.kind === 'comment' && action.enabledChatgpt) as boolean,
        events: [...state.events, action.event].sort((a, b) => a.position - b.position)
      }
    }
    case EventActions.UPDATE_EVENT_ON_STATIC_CONTENT: {
      const updateIndex = state.events.findIndex((e) => e.id === action.event.id)
      // 存在しなければ何もしない
      if (updateIndex === -1) return state
      
      // 更新
      state.events[updateIndex] = action.event

      return {
        ...state,
        events: [...state.events]
      }
    }
    case EventActions.REMOVE_EVENT_ON_STATIC_CONTENT: {
      const removeIndex = state.events.findIndex((e) => e.id === action.eventId)
      // 存在しなければ何もしない
      if(removeIndex === -1) return state

      // 削除
      state.events.splice(removeIndex, 1)

      return {
        ...state,
        events: [...state.events]
      }
    }

    default: {
      return state
    }
  }
}



// WEBPACK FOOTER //
// ./src/reducers/event.ts